import { render, staticRenderFns } from "./WidgetCarouselTabs.vue?vue&type=template&id=ccd3b10e&scoped=true"
import script from "./WidgetCarouselTabs.vue?vue&type=script&lang=js"
export * from "./WidgetCarouselTabs.vue?vue&type=script&lang=js"
import style0 from "./WidgetCarouselTabs.vue?vue&type=style&index=0&id=ccd3b10e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccd3b10e",
  null
  
)

export default component.exports